<section class="modal-container aberration-extra-details extra-details-width">
  <div class="aberration-extra-details_top-bar">
    <div class="aberration-extra-details_top-bar_header-bar">
      <div #headersParent class="aberration-extra-details_top-bar_header-bar_content">
        <div *ngIf="enableHeaderScrollLeft" class="aberration-extra-details_top-bar_header-bar_content_scroll-left" (click)="scrollHeadersLeft()"></div>
        <div *ngIf="enableHeaderScrollRight" class="aberration-extra-details_top-bar_header-bar_content_scroll-right" (click)="scrollHeadersRight()"></div>
        <div class="aberration-extra-details_top-bar_header-bar_content_mask"></div>
        <div #headersContent class="aberration-extra-details_top-bar_header-bar_content_headers">
          <div class="aberration-extra-details_top-bar_header-bar_content_headers_header" *ngFor="let title of headers" id={{title.name}}>
            <span class="aberration-extra-details_top-bar_header-bar_content_headers_header_title" translate>{{'aberration.' + title.name}}</span>
            <div [ngSwitch]="title.type">
              <indicator-icon *ngSwitchCase="'indicator-icon-column'"
                         class="aberration-extra-details_top-bar_header-bar_content_headers_header_color-box"
                         [value]="title.values" [data]="title.columnData"></indicator-icon>
              <color-box *ngSwitchCase="'color-box-column-ngjs'"
                         class="aberration-extra-details_top-bar_header-bar_content_headers_header_color-box"
                         [text]="title.values[title.name]" [config]="title.columnData.configuration"></color-box>
              <color-text *ngSwitchCase="'color-text-column-ngjs'"
                          class="aberration-extra-details_top-bar_header-bar_content_headers_header_color-text"
                          [text]="title.values[title.name]" [config]="title.columnData.configuration"></color-text>
              <span *ngSwitchDefault class="aberration-extra-details_top-bar_header-bar_content_headers_header_content" [innerHTML]="title.values[title.name]"></span>
            </div>
          </div>
        </div>
      </div>
      <dls-dialog-header><span class="pt-icon close-btn icon__cross crossButton" (click)="closeThisDialog({action:'cancel'})"></span></dls-dialog-header>
    </div>

    <div class="aberration-extra-details_top-bar_tool-bar">
      <div class="aberration-extra-details_top-bar_tool-bar_left">
        <div class="aberration-extra-details_top-bar_tool-bar_left_filter">
          <span class="aberration-extra-details_top-bar_tool-bar_left_filter_label wordBreak">Results:</span>
          <select class="aberration-extra-details_top-bar_tool-bar_left_filter_selection form-control selection" [formControl]="aberrationsFilterControl">
            <option class="aberration-extra-details_top-bar_tool-bar_left_filter_selection_option" [ngValue]="'NotFiltered'" translate>NotFiltered</option>
            <option class="aberration-extra-details_top-bar_tool-bar_left_filter_selection_option" [ngValue]="'Filtered'" [disabled]="!enableFilterQuery" translate>Filtered</option>
            <option class="aberration-extra-details_top-bar_tool-bar_left_filter_selection_option" [ngValue]="'Selected'" [disabled]="!enableFilterSelections" translate>Selected</option>
          </select>
        </div>

      </div>
      <div class="aberration-extra-details_top-bar_tool-bar_center">
        <div *ngIf="!!currentAberration" class="aberration-extra-details_top-bar_tool-bar_center_nav">
          <div class="aberration-extra-details_top-bar_tool-bar_center_nav_prev" (click)="previousAberration()">
            <span class="aberration-extra-details_top-bar_tool-bar_center_nav_prev_icon"></span>
            <span class="aberration-extra-details_top-bar_tool-bar_center_nav_prev_label">Prev</span>
          </div>
          <div class="aberration-extra-details_top-bar_tool-bar_center_nav_next" (click)="nextAberration()">
            <span class="aberration-extra-details_top-bar_tool-bar_center_nav_next_label">Next</span>
            <span class="aberration-extra-details_top-bar_tool-bar_center_nav_next_icon"></span>
          </div>
        </div>
      </div>
      <div class="aberration-extra-details_top-bar_tool-bar_right">
        <div *ngIf="searchItems.length > 0" class="aberration-extra-details_top-bar_tool-bar_right_resources">
          <p-tieredMenu #menu [appendTo]="'body'" [styleClass]="'web-links-popup'" [baseZIndex]="10001"  [model]="searchItems" [popup]="true"></p-tieredMenu>
          <button type="button" class="web-resources-button btn" (click)="menu.toggle($event)">Web Resources<em class="icon__ArrowDown"></em></button>
        </div>

        <div class="aberration-extra-details_top-bar_tool-bar_right_selection" *ngIf="testTableData.aberrationExtraDetails.allowSelections && selections && currentAberration">
          <span class="aberration-extra-details_top-bar_tool-bar_right_selection_label">Selected:</span>
          <gen-toggle-switch class="aberration-extra-details_top-bar_tool-bar_right_selection_switch"
                             [active]="selections[currentAberration.id]"
                             [disabled]="(currentOpinion && currentOpinion.state !== 'review') || shouldDisableSelectionForModality()"
                             (statusUpdate)="toggleSelection($event)"></gen-toggle-switch>
        </div>
      </div>
    </div>
  </div>

  <gen-tabs-header class="aberration-extra-details_tabs" styleModifier="'tabs-wrapper-aberration'"
                   [tabs]="tabs"
                   (tabChange)="onTabChange($event)"
  ></gen-tabs-header>

  <gen-overlay-loader class="aberration-extra-details_dialog-loader"
                      *ngIf="loading"
                      [showOverlay]="false"
  ></gen-overlay-loader>

  <div class="Flexbox aberration-extra-details_content aberration-tabs-container">
    <ng-template #tabChild></ng-template>
  </div>
</section>
<gen-dynamic-modal-loader [observableName]="'ABERRATIONS_POPUP_MODAL_LOADER'"></gen-dynamic-modal-loader>
